'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _SvgContainer = require('./SvgContainer');
var _SvgContainer2 = _interopRequireDefault(_SvgContainer);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var BeakerSharp = function BeakerSharp(props) {
  return _react2.default.createElement(_SvgContainer2.default, {
    height: props.height,
    width: props.width,
    color: props.color,
    onClick: props.onClick,
    rotate: props.rotate ? 1 : 0,
    shake: props.shake ? 1 : 0,
    beat: props.beat ? 1 : 0,
    className: props.className
  }, _react2.default.createElement('svg', {
    style: props.style,
    className: props.cssClasses,
    xmlns: 'http://www.w3.org/2000/svg',
    viewBox: '0 0 512 512'
  }, props.title ? _react2.default.createElement('title', null, props.title) : '', _react2.default.createElement('path', {
    d: 'M453.55 54.7L464 32H128.4c-27.74 0-49 6.57-63.31 19.51C54.39 61.27 48 74.89 48 88v24h16c31 0 32 16.79 32 35v313a20 20 0 0020 20h312a20 20 0 0020-20V96c0-17.16 2.28-34.14 5.55-41.3zM416 96v64H128v-22c0-36.15-21-51-41.77-53.46C89 70 105.7 64.05 128.4 64.05h289.92A221.83 221.83 0 00416 96z'
  })));
};
BeakerSharp.defaultProps = {
  // style
  style: {},
  color: '#000000',
  height: '22px',
  width: '22px',
  cssClasses: '',
  title: '',
  // animation
  shake: false,
  beat: false,
  rotate: false
};
BeakerSharp.propTypes = {
  // style
  style: _propTypes2.default.object,
  color: _propTypes2.default.string,
  height: _propTypes2.default.string,
  width: _propTypes2.default.string,
  cssClasses: _propTypes2.default.string,
  title: _propTypes2.default.string,
  // animation
  shake: _propTypes2.default.bool,
  beat: _propTypes2.default.bool,
  rotate: _propTypes2.default.bool,
  // functions
  onClick: _propTypes2.default.func
};
exports.default = BeakerSharp;
module.exports = exports['default'];